export const CALENDLY = "https://calendly.com/emeraldglobaladvisory/30min";
export const PRIVACY = "https://gamma.app/docs/Emerald-Global-Advisory-Privacy-Policy-2gumx6xa5w8wsyx";
export const EMAIL = "info@emeraldglobaladvisory.com";
export const FOUNDER_GRANT_ACHIEVEMENT = "Ananya has supported clients in raising over $1.4 million in grant funding.";

export const NAV = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/contact", label: "Contact" },
];

export const TESTIMONIALS = [
  {
    id: "nasteha-muse",
    name: "Nasteha Muse",
    role: "Founder & CEO, Inspire Kids ELC, USA",
    logo: "/assets/t1.png",
    quote: "Working with Emerald Global Advisory has been one of the most impactful decisions for our business. From grant applications to accounting clean-up and long-term financial strategy, the support has been truly end-to-end.",
  },
  {
    id: "panashe-sivindani",
    name: "Panashe Sivindani",
    role: "Founder & CEO, FlameLily Foundation, USA",
    logo: "/assets/t2.png",
    quote: "Emerald Global Advisory helped simplify our accounts that were in overwhelmingly fragmented systems and made everything well arranged with great communication and professionalism.",
  },
];

export const WHY = [
  { title: "A person, not a portal.", text: "Founder-led guidance shaped by Ananya's decade in corporate finance at Barclays and PACCAR. A thinking partner for your decisions, not just another report in your inbox." },
  { title: "Clarity before complexity.", text: "Understand what your numbers mean, what needs attention and what to do next. We turn financial information into conversations you can act on." },
  { title: "Built around your stage.", text: "Start with a clean-up, build a monthly finance rhythm or add strategic guidance as decisions get bigger. Choose the support you need, without jumping straight to a full-time finance team." },
];

export const CORE_SERVICES = [
  { id: "finance-foundations", tag: "Finance Foundations", title: "Know where your business stands.", text: "Bookkeeping oversight, monthly accounts and clear reporting, so you can stop piecing together the story from scattered spreadsheets.", fit: "For solopreneurs, early-stage founders and small teams building their first finance routine." },
  { id: "business-growth", tag: "Business Growth", title: "Plan your next move, not just your next month.", text: "Budgets, cash flow forecasts and grant support that help you weigh hiring, spending and funding decisions before you commit.", fit: "For established small businesses, education providers and nonprofits ready to plan ahead." },
  { id: "strategic-finance", tag: "Strategic Finance", title: "Bring a finance partner into bigger decisions.", text: "Fractional CFO guidance, scenario modelling and investor-ready reporting for the moments when a spreadsheet alone is not enough.", fit: "For growing startups and founders preparing for funding, expansion or board conversations." },
];

export const PACKAGES = [
  {
    id: "finance-foundations", name: "Finance Foundations",
    size: { usd: "Under $250k", gbp: "Under £200k", employees: "1–5" },
    ideal: "Solopreneurs, women-led small businesses and early-stage startups that need dependable monthly numbers, not a full finance department.",
    pain: "Your accounts take up evenings, reports arrive late and you are not sure which numbers to trust.",
    outcome: "A consistent view of income, costs and key indicators, with monthly review notes that explain what deserves your attention.",
    items: ["Bookkeeping oversight", "Monthly financial statements", "Accounts payable & receivable review", "KPI tracking", "Monthly review notes over 20 min video recording"],
  },
  {
    id: "business-growth", name: "Business Growth",
    size: { usd: "$250k–$1m", gbp: "£200k–£800k", employees: "6–20" },
    ideal: "Established small businesses, education providers and purpose-driven organisations balancing growth plans with limited cash and resources.",
    pain: "Sales or programmes are growing, but you cannot confidently judge what you can afford next.",
    outcome: "A working budget, clearer cash flow forecasts and regular strategic reviews to make trade-offs with more confidence.",
    items: ["Everything in Finance Foundations", "Budgeting & forecasting", "Cash flow management", "Variance analysis & performance insights", "Grant Readiness & Application", "Quarterly strategic live-review"],
  },
  {
    id: "strategic-finance", name: "Strategic Finance",
    size: { usd: "Over $1m", gbp: "Over £800k", employees: "21+" },
    ideal: "Growth-stage and tech startup founders preparing for fundraising, expansion or regular board and investor discussions.",
    pain: "High-stakes decisions keep landing on your desk, without a senior finance partner to test the assumptions.",
    outcome: "Fractional CFO guidance, scenario models and reporting that make your financial story easier to explain and challenge.",
    items: ["Everything in Business Growth", "Fractional CFO guidance (10–20 hrs/month)", "Board & investor-ready reports", "Grant compliance & optimization", "Strategic modeling & scenario planning"],
  },
  {
    id: "project-one-time", name: "Project / One-Time",
    ideal: "Businesses at any stage with a defined need: overdue books, a system change, a financial model or a specific grant opportunity.",
    pain: "One unresolved finance task is holding everything else up, but you do not need an ongoing package yet.",
    outcome: "A focused scope and a practical handover, so you can move forward without taking on a recurring engagement.",
    items: ["Accounting System Onboarding and setup", "Bookkeeping catch-up/clean-up", "Budget & financial reporting dashboard setup", "Grant readiness and submission", "Financial modeling projects"],
  },
];

export const STEPS = [
  { title: "First conversation", text: "Tell us what is taking your time, keeping you guessing or holding your business back." },
  { title: "A clear scope", text: "Agree on priorities, deliverables and the level of support before work begins." },
  { title: "Get organised", text: "Bring your accounts, systems and reporting into a more useful working rhythm." },
  { title: "Make sense of it", text: "Review the numbers together and connect them to the decisions in front of you." },
  { title: "Look ahead", text: "For ongoing engagements, revisit your plan as your business and priorities evolve." },
];

export const TOOLS = [
  { name: "QuickBooks", src: "/assets/quickbooks.svg" },
  { name: "Zoho Books", src: "/assets/zoho.png" },
  { name: "Xero", src: "/assets/xero.png" },
  { name: "Zoho", src: "/assets/tool4.png" },
  { name: "Google Gemini", src: "/assets/gemini.png" },
  { name: "Google Workspace", src: "/assets/workspace.png" },
  { name: "Claude", src: "/assets/claude.png" },
  { name: "Puzzle", src: "/assets/puzzle.png" },
];

export const PHONES = [
  { region: "US", number: "+1 (425) 802-8742", href: "tel:+14258028742" },
  { region: "UK", number: "+44 7818 971429", href: "tel:+447818971429" },
  { region: "IND", number: "+91 72660 11548", href: "tel:+917266011548" },
];

export const OFFICES = [
  { region: "United Kingdom", label: "Registered Office (UK)", address: "71-75 Shelton Street, Covent Garden, London, United Kingdom, WC2H 9JQ" },
  { region: "India", label: "Registered Office (India)", address: "131/84 Kanoon Goyan, Near Police Chowki Bareilly, Uttar Pradesh 243005, India" },
];

export const SOCIALS = [
  { name: "LinkedIn", href: "https://www.linkedin.com/company/emerald-global-advisory/" },
  { name: "Instagram", href: "https://www.instagram.com/emeraldglobaladvisory/" },
  { name: "Facebook", href: "https://www.facebook.com/profile.php?id=61579733081305#" },
  { name: "YouTube", href: "https://www.youtube.com/@Emerald_Global_Advisory" },
];
